import { Provider } from 'react-redux';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { store } from './redux/store';
import Layout from './components/Layout';
import Home from './components/Home';
import Counter from './components/Counter';
import Stub from './components/Stub';
import TaskConstructor from './components/taskConstructor/TaskConstructor';
import ChessTournament from './components/chessTournament/ChessTournament';
import './App.css';

function App() {
    return (
        <Provider store={store}>
            <Router>
                <Routes>
                    {/* Корень сайта сразу ведёт на турнир; прежняя главная доступна по /home */}
                    <Route path="/" element={<Navigate to="/tournament" replace />} />
                    <Route path="/home" element={<Layout><Home /></Layout>} />
                    <Route path="/counter" element={<Layout><Counter /></Layout>} />
                    <Route path="/stub1" element={<Layout><Stub /></Layout>} />
                    <Route path="/stub2" element={<Layout><Stub /></Layout>} />
                    <Route path="/task-constructor" element={<Layout><TaskConstructor /></Layout>} />
                    <Route path="/tournament" element={<Layout><ChessTournament /></Layout>} />
                </Routes>
            </Router>
        </Provider>
    );
}

export default App;